module.exports = __webpack_public_path__ + "img/ms-2.b4dc7354.webp";